import modalMixin from '../../../mixins/_modal';

// 発送予定タイプ定義
const CART_LEAD_TIME_TYPE = {
    // ○日に発送予定
    AFTER: 1
};

/**
 * 出荷予定日のパターンコンポーネント
 */
export default {
    name: 'CartLeadTimeEdit',
    template: '#cart_lead_time_edit_template',
    data() {
        return {
            // 編集中のデータ
            data: {},
            message: '',
        };
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({}),
            required: false
        }
    },
    mixins: [
        modalMixin,
    ],
    computed: {
        // 更新可能状態か
        isValid: function () {
            // ○日に発送予定は除外
            if (Number(this.data.cart_lead_time_type) === CART_LEAD_TIME_TYPE.AFTER) {
                return true;
            }
            const from = this.data.cart_lead_time_from_num;
            const to   = this.data.cart_lead_time_to_num;

            // 空の場合はtrueにしてrequiredエラーで対応する
            if (from === null || from === '' || to === null || to === '') {
                return true;
            }
            // 最大日数の方が小さい数字が入っている
            if (Number(from) >= Number(to)) {
                this.message = '期間終了日に、期間開始日より大きい数字が入力されています。';
                return false;
            }
            // 期間が2日以上
            if ((Number(to) - Number(from)) > 2) {
                this.message = '期間指定のレンジは「2日」以内にしてください。';
                return false;
            }
            return true;
        }
    },
    emits: ['update:modelValue'],
    methods: {
        // モーダルを開いたら編集中データへ代入
        opening: function () {
            this.data = _.cloneDeep(this.modelValue);
        },
        // データを更新してモーダルを閉じる
        update: function (event) {
            // 未入力エラーの場合はそのままフォーム送信する
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();
            if (!this.isValid) {
                swal(this.message);
                return;
            }
            this.emitUpdatValue();
            this.close();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集内容で更新
        emitUpdatValue: function () {
            this.$emit('update:modelValue', this.data);
        }
    }
};
